import { render, staticRenderFns } from "./FormNotification.vue?vue&type=template&id=eabb6e76"
import script from "./FormNotification.vue?vue&type=script&lang=js"
export * from "./FormNotification.vue?vue&type=script&lang=js"
import style0 from "./FormNotification.vue?vue&type=style&index=0&id=eabb6e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports